import { EJsonQueryReadyBusinessType } from '../../../../packages/api-models/common/json_query';
import { ISelectOption } from 'shared/types/filters';

export const READY_BUSINESS_TYPES_OPTIONS: ISelectOption[] = [
  { label: 'Арендный бизнес', value: EJsonQueryReadyBusinessType.RentalBusiness },
  { label: 'Готовый бизнес', value: EJsonQueryReadyBusinessType.ReadyBusiness },
];
